module.exports = __webpack_public_path__ + "img/202408_09.8bdacffb.jpg";